module.exports = __webpack_public_path__ + "media/images/flags/32/Yemen-5af9aec66bbde79044c6ca9315d76687.png";